import React, { Component } from 'react'
import { Collapse, CardBody, Card } from 'reactstrap';
import { Link } from 'react-router-dom'
import { withTranslation } from 'react-i18next'
import './style.css';

const menus = [
    {
        id: 1,
        titleKey: 'home',
        link: '/',
        isSection: false,
    },

    {
        id: 2,
        titleKey: 'aboutNav',
        link: 'about',
        isSection: true,
    },

    {
        id: 3,
        titleKey: 'featuresNav',
        link: 'features',
        isSection: true,
    },

    {
        id: 4,
        titleKey: 'assessment',
        link: 'level-test',
        isSection: true,
    },

    {
        id: 5,
        titleKey: 'contact',
        link: 'contact',
        isSection: true,
    }
]


class MobileMenu extends Component {

    state = {
        isMenuShow: false,
        isOpen: 0,
    }

    menuHandler = () => {
        this.setState({
            isMenuShow: !this.state.isMenuShow
        })
    }

    setIsOpen = id => () => {
        this.setState({
            isOpen: id === this.state.isOpen ? 0 : id
        })
    }

    scrollToSection = (sectionId) => (e) => {
        e.preventDefault();
        this.menuHandler(); // Close mobile menu
        setTimeout(() => {
            const element = document.getElementById(sectionId);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }, 300);
    }

    render() {
        const { isMenuShow, isOpen } = this.state;
        const { t } = this.props; // Translation function

        const ClickHandler = () => {
            window.scrollTo(10, 0);
        }

        return (
            <div>
                <div className={`mobileMenu ${isMenuShow ? 'show' : ''}`}>
                    <div className="menu-close">
                        <div className="clox" onClick={this.menuHandler}><i className="ti-close"></i></div>
                    </div>

                    <ul className="responsivemenu">
                        {menus.map(item => {
                            return (
                                <li key={item.id}>
                                    {item.isSection ? (
                                        <a href={`#${item.link}`} onClick={this.scrollToSection(item.link)}>
                                            {t(item.titleKey)}
                                        </a>
                                    ) : (
                                        <Link onClick={ClickHandler} to={item.link}>{t(item.titleKey)}</Link>
                                    )}
                                </li>
                            )
                        })}

                        {/* Auth buttons in mobile menu */}
                        <li className="mobile-auth-buttons">
                            <Link onClick={this.menuHandler} to="/login" className="mobile-auth-btn mobile-signin-btn">
                                {t('login')}
                            </Link>
                        </li>
                        <li className="mobile-auth-buttons">
                            <Link onClick={this.menuHandler} to="/signup" className="mobile-auth-btn mobile-signup-btn">
                                {t('signupNav')}
                            </Link>
                        </li>
                    </ul>

                </div>

                <div className="showmenu" onClick={this.menuHandler}>
                    <button type="button" className="navbar-toggler open-btn">
                        <span className="icon-bar first-angle"></span>
                        <span className="icon-bar middle-angle"></span>
                        <span className="icon-bar last-angle"></span>
                    </button>
                </div>
            </div>
        )
    }
}

export default withTranslation()(MobileMenu)